<p-card class="p-card container">
  <h3 i18n>Plan du client</h3>

  <div class="flex flex-row gap-3">
    <em-protection-summary
      class="w-6 h-full"
      i18n-title
      title="Protection initiale"
      [protectionSummary]="_surchargeSummary.protectionSummary"></em-protection-summary>

    @if (_surchargeSummary.surchargedProtectionSummary) {
      <em-protection-summary
        class="w-6 h-full"
        i18n-title
        title="Protection avec surprime"
        [protectionSummary]="_surchargeSummary.surchargedProtectionSummary"
        [isUpdatingSurcharge]="isUpdatingSurcharge"></em-protection-summary>
    } @else {
      <div class="flex flex-column w-6 layout__inner-card">
        <h3 class="text-primary text-center" i18n>Protection avec surprime</h3>
        @if (isUpdatingSurcharge) {
          <p-progressSpinner class="m-auto" styleClass="w-2rem h-2rem" strokeWidth="8"></p-progressSpinner>
        }
        @if (!isUpdatingSurcharge) {
          <p i18n class="font-italic m-auto">Aucune surprime</p>
        }
      </div>
    }
  </div>

  <div class="flex flex-column align-items-center layout__inner-card gap-5">
    <div class="flex flex-column w-6 align-content-center">
      <h3 class="text-center" i18n>Taux de surprime</h3>
      <p-dropdown
        class="text-center"
        [options]="surchargeOptions | emTranslate"
        optionLabel="name"
        optionValue="value"
        i18n-placeholder
        placeholder="Choisir"
        [formControl]="form"></p-dropdown>
    </div>

    <div class="flex flex-row w-full align-items-center gap-4">
      <p-button
        [loading]="isApproveLoading"
        (onClick)="openProfileApprovalPopup(false)"
        [disabled]="isReadonly || isUpdatingSurcharge"
        class="w-full"
        icon="pi pi-check"
        i18n-label
        label="Approuver"></p-button>
      <p-button
        [loading]="isConditionalApproveLoading"
        (onClick)="openProfileApprovalPopup(true)"
        [disabled]="isReadonly || isUpdatingSurcharge"
        class="emma-pro-white-btn w-full"
        icon="pi pi-check"
        i18n-label
        label="Approuver avec condition"></p-button>
      <p-button
        (onClick)="openProfileRefusalPopup()"
        [disabled]="isReadonly || isUpdatingSurcharge"
        class="emma-pro-delete-btn w-full"
        icon="pi pi-times"
        i18n-label
        label="Refuser"></p-button>
    </div>
  </div>
</p-card>

<em-profile-refusal-popup
  [(isDisplayed)]="isProfileRefusalPopupDisplayed"
  [info]="refusalPopupInfo"
  (submitRefusal)="onProfileRefused($event)"></em-profile-refusal-popup>
